import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import api from '@frontend/api/axios';
import { useWalletValue } from '@frontend/hooks/useWalletValue';
import { backendUrl } from '@jdiyield/constants';
import { createContext, useContext, useEffect, useState } from 'react';
var INITIAL_SHORT_NAME = 'USD';
var INITIAL_SYMBOL = '$';
var initialState = {
  loading: false,
  currencyList: []
};
var CurrencyContext = /*#__PURE__*/createContext(_objectSpread(_objectSpread({}, initialState), {}, {
  selectedCurrency: INITIAL_SHORT_NAME,
  symbol: INITIAL_SYMBOL,
  refetch: function refetch() {
    return null;
  },
  convertCurrency: function convertCurrency() {
    return null;
  },
  handleSetSelectedCurrency: function handleSetSelectedCurrency() {
    return null;
  }
}));
export var useCurrencyContext = function useCurrencyContext() {
  return useContext(CurrencyContext);
};
export var CurrencyProvider = function CurrencyProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(INITIAL_SHORT_NAME),
      selectedCurrency = _useState[0],
      setSelectedCurrency = _useState[1];

  var _useState2 = useState(INITIAL_SYMBOL),
      symbol = _useState2[0],
      setSymbol = _useState2[1];

  var _useWalletValue = useWalletValue(initialState, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(setValue) {
      var _yield$api$get$catch, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setValue(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  loading: true
                });
              });
              _context.next = 3;
              return api.get("".concat(backendUrl, "/currency"))["catch"](function () {
                return {
                  data: []
                };
              });

            case 3:
              _yield$api$get$catch = _context.sent;
              data = _yield$api$get$catch.data;
              setValue(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  currencyList: data || [],
                  loading: false
                });
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []),
      _useWalletValue2 = _slicedToArray(_useWalletValue, 2),
      _useWalletValue2$ = _useWalletValue2[0],
      currencyList = _useWalletValue2$.currencyList,
      loading = _useWalletValue2$.loading,
      refetch = _useWalletValue2[1].refetch;

  var handleSetSelectedCurrency = function handleSetSelectedCurrency(currency) {
    var findCurrency = currencyList.find(function (f) {
      return f.shortName === currency;
    });

    if (findCurrency) {
      setSelectedCurrency(findCurrency.shortName);
      setSymbol(findCurrency.symbol);
      localStorage.setItem('selected-currency', JSON.stringify({
        name: findCurrency.shortName,
        symbol: findCurrency.symbol
      }));
    }
  };

  var convertCurrency = function convertCurrency(amount) {
    if (selectedCurrency === INITIAL_SHORT_NAME) return Number(amount);
    var findCurrency = currencyList.find(function (f) {
      return f.shortName === selectedCurrency;
    });

    if (findCurrency) {
      return Number(amount) * findCurrency.price;
    }

    return Number(amount);
  };

  var handleRefetch = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (loading) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return refetch();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleRefetch() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    try {
      var getSelectedCurrency = JSON.parse(localStorage.getItem('selected-currency'));
      setSelectedCurrency((getSelectedCurrency === null || getSelectedCurrency === void 0 ? void 0 : getSelectedCurrency.name) || INITIAL_SHORT_NAME);
      setSymbol((getSelectedCurrency === null || getSelectedCurrency === void 0 ? void 0 : getSelectedCurrency.symbol) || INITIAL_SYMBOL);
    } catch (_unused) {
      setSelectedCurrency(INITIAL_SHORT_NAME);
      setSymbol(INITIAL_SYMBOL);
    }
  }, []);
  return _jsx(CurrencyContext.Provider, {
    value: {
      currencyList: currencyList,
      selectedCurrency: selectedCurrency,
      symbol: symbol,
      loading: loading,
      refetch: handleRefetch,
      handleSetSelectedCurrency: handleSetSelectedCurrency,
      convertCurrency: convertCurrency
    },
    children: children
  });
};